import { render, staticRenderFns } from "./fbmRotateSpinner.vue?vue&type=template&id=60b556b0"
import script from "./fbmRotateSpinner.vue?vue&type=script&lang=js"
export * from "./fbmRotateSpinner.vue?vue&type=script&lang=js"
import style0 from "./fbmRotateSpinner.vue?vue&type=style&index=0&id=60b556b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports